import { notification } from "antd";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { getFileBase64 } from "../../../utils/commonFunctions";
import styles from "../styles/style.module.scss";
import Input from "../../input";
import Session from "./session";
import TextArea from "../../textarea";
import addImage from "../../../images/add.svg";
import moment from "moment";


const TrainingSessionDetails = ({
  setTrainingData,
  type,
  trainingData,
  setCurrentStep,
  setImageUpdated,
}) => {
  const [errorArray, setErrorArray] = useState([]);
  const [sessionErrorArray, setSessionErrorArray] = useState([]);
  const addChild = () => {
    setTrainingData({
      ...trainingData,
      sessions: [
        ...trainingData.sessions,
        {
          title: "",
          startDateTime: moment().format(),
          duration: null,
          meetingLink: "",
          teacherName: "Trainer",
        },
      ],
    });
  };

  useEffect(() => {
    if (trainingData.sessions.length < 1) {
      setTrainingData({
        ...trainingData,
        sessions: [
          ...trainingData.sessions,
          {
            title: "",
            startDateTime: moment().format(),
            duration: null,
            meetingLink: "",
            teacherName: "Trainer",
          },
        ],
      });
    }
  }, [trainingData]);

  const handleSessionDelete = ({ deleteIndex }) => {
    setTrainingData({
      ...trainingData,
      sessions: trainingData.sessions.filter(
        (session, index) => index !== deleteIndex
      ),
    });
  };

  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;

    setTrainingData({
      ...trainingData,
      [name]: name === "masterBootcamp" ? checked : value,
    });
  };

  const onFileUpload = async (event) => {
    const file = event.target.files?.[0];
    if (file) {
      const base64 = await getFileBase64(file);

      setTrainingData({
        ...trainingData,
        imageLink: base64,
      });
      setImageUpdated(true);
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Try again later`,
      });
    }
  };

  const checkFields = () => {
    let error = [];
    Object.keys(trainingData).forEach((key) => {
      if (
        trainingData !== "meetingKey" &&
        trainingData !== "platformType" &&
        trainingData !== "instanceId" &&
        trainingData !== "trainingRecordingLink" &&
        (trainingData[key] === null || trainingData[key] === "")
      ) {
        error.push(key);
      } else if (key === "sessions") {
        let sessionsError = [];

        trainingData[key].forEach((currentSession) => {
          let currentSessionErrorArray = [];
          Object.keys(currentSession).forEach((sessionKey) => {
            if (
              currentSession[sessionKey] === null ||
              currentSession[sessionKey] === ""
            ) {
              if (sessionKey !== "recordingLink") {
                currentSessionErrorArray.push(sessionKey);
              }
            }
          });

          sessionsError.push(currentSessionErrorArray);
        });

        let allSessionErrorResolved = true;

        sessionsError.forEach((currentSessionErrorArray) => {
          if (currentSessionErrorArray.length > 0) {
            allSessionErrorResolved = false;
          }
        });

        if (allSessionErrorResolved) {
          setSessionErrorArray([]);
          error = error.filter((currentError) => {
            return typeof currentError === "string";
          });
        } else {
          setSessionErrorArray([...sessionsError]);
          error.push({ session: sessionsError });
        }
      }
    });

    setErrorArray([...error]);

    console.log({ error });
    if (error.length === 0) {
      setCurrentStep(2);
    }
  };

  return (
    <>
      <Input
        error={errorArray.includes("title")}
        label="Training Title"
        type={"text"}
        placeholder={"Enter title"}
        value={trainingData.title}
        name={"title"}
        onChangeHandler={handleInputChange}
      />

      <div className={styles.programDuration}>
        <Input
          error={errorArray.includes("duration")}
          label="Training Duration"
          type="number"
          placeholder="Enter duration"
          value={trainingData.duration}
          name="duration"
          onChangeHandler={handleInputChange}
        />

        <select
          value={trainingData.durationType}
          name="durationType"
          onChange={handleInputChange}
        >
          <option value="week">Week</option>
          <option value="month">Month</option>
          <option value="year">Year</option>
        </select>
      </div>

      <Input
        error={errorArray.includes("discordLink")}
        label="Discord Link"
        type="text"
        placeholder="Enter Discord Link"
        value={trainingData.discordLink}
        name="discordLink"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("contentLink")}
        label="Content Link"
        type="text"
        placeholder="Enter Content Link"
        value={trainingData.contentLink}
        name="contentLink"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("maximumSeats")}
        label="Maximum seats"
        disabled={type === "EDIT"}
        type="number"
        placeholder="Enter Maximum Seats"
        value={trainingData.maximumSeats}
        name="maximumSeats"
        onChangeHandler={handleInputChange}
      />
      <Input
        error={errorArray.includes("availableSeats")}
        label="Available Seats"
        disabled={type === "EDIT"}
        type="number"
        placeholder="Enter Available Seats"
        value={trainingData.availableSeats}
        name="availableSeats"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("registrationLink")}
        label="Registration link"
        type="text"
        placeholder="Enter Registration link"
        value={trainingData.registrationLink}
        name="registrationLink"
        onChangeHandler={handleInputChange}
      />
      <TextArea
        error={errorArray.includes("description")}
        label="Description"
        type="text"
        placeholder="Enter description"
        value={trainingData.description}
        name="description"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("role")}
        label="Role"
        type="text"
        placeholder="Enter Role"
        value={trainingData.role}
        name="role"
        onChangeHandler={handleInputChange}
      />
      <Input
        error={errorArray.includes("alternateName")}
        label="Alternate Name"
        type="text"
        placeholder="Enter Alternate Name"
        value={trainingData.alternateName}
        name="alternateName"
        onChangeHandler={handleInputChange}
      />

      <Input
        error={errorArray.includes("imageLink")}
        label="Upload image"
        type="file"
        name="imageLink"
        accept="image/*"
        onChangeHandler={onFileUpload}
      />
      {trainingData.imageLink && (
        <img
          style={{
            margin: "20px 0 20px 50px",
            objectFit: "contain",
            height: "200px",
            width: "auto",
          }}
          src={trainingData.imageLink}
        />
      )}

      <Input
        label="Meeting Key"
        type="text"
        placeholder="Meeting Key"
        value={trainingData.meetingKey}
        name="meetingKey"
        onChangeHandler={handleInputChange}
      />

      <Input
        label="Platform Type"
        type="text"
        placeholder="Enter Platform Type"
        value={trainingData.platformType}
        name="platformType"
        onChangeHandler={handleInputChange}
      />

      <Input
        label="Instance Id"
        type="text"
        placeholder="Instance Id"
        value={trainingData.instanceId}
        name="instanceId"
        onChangeHandler={handleInputChange}
      />

      <Input
        label="Training Recording Link"
        type="text"
        placeholder="Enter Training Recording Link"
        value={trainingData.trainingRecordingLink}
        name="trainingRecordingLink"
        onChangeHandler={handleInputChange}
      />

      {type !== "EDIT" && (
        <Input
          label="Is Masterbootcamp ?"
          type="checkbox"
          checked={trainingData.masterBootcamp ? true : false}
          name="masterBootcamp"
          onChangeHandler={handleInputChange}
        />
      )}

      <div className={styles.sessionList}>
        <label className={styles.sessionListLabel}>Training Session</label>
        <div className={styles.addNewSessionPanel}>
          {trainingData.sessions.map((currentSession, index) => {
            return (
              <Session
                index={index}
                errorArray={
                  sessionErrorArray[index] ? sessionErrorArray[index] : []
                }
                sessions={trainingData.sessions}
                setTrainingData={setTrainingData}
                handleSessionDelete={handleSessionDelete}
              />
            );
          })}
          <img
            className={styles.addButton}
            src={addImage}
            onClick={addChild}
            height={35}
            width={35}
          />
        </div>
      </div>
      <div className={styles.sessionCompletionButton}>
        <Button
          variant="primary"
          className={styles.saveProceed}
          onClick={() => checkFields()}
        >
          Save & Proceed
        </Button>
      </div>
    </>
  );
};

export default TrainingSessionDetails;
